import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useTranslate } from 'react-admin';
import { useFormContext, useWatch } from 'react-hook-form';
import AllProductsIcon from '@/assets/icons/all-products-icon.svg?react';
import PackageIcon from '@/assets/icons/products-collected-icon.svg?react';
import ProductsIcon from '@/assets/icons/products-icon.svg?react';
import OptionSelectButton from './OptionSelectButton.jsx';
import { Palette } from '@/themes/themeOverrides/Palette.js';

export default function ProductScopeSelector() {
    const translate = useTranslate();
    const { setValue, register } = useFormContext();
    const productScope = useWatch({ name: 'productScope' });

    useEffect(() => {
        register('productScope');
    }, [register]);

    const options = [
        { value: 'all', label: translate('campaign.scope.all'), icon: <AllProductsIcon /> },
        { value: 'group', label: translate('campaign.scope.group'), icon: <PackageIcon /> },
        { value: 'single', label: translate('campaign.scope.single'), icon: <ProductsIcon /> },
    ];

    const handleSelect = value => {
        setValue('productScope', value, { shouldDirty: true, shouldTouch: true });
    };

    return (
        <Box
            role='group'
            aria-label={translate('resources.campaign.labels.productScope')}
            sx={{
                display: 'flex',
                borderRadius: '16px',
                backgroundColor: Palette.gray.gray75,
                overflow: 'hidden',
                border: `2px solid ${Palette.gray.gray150}`,
                width: '100%',
            }}
        >
            {options.map((opt, idx) => (
                <OptionSelectButton
                    key={opt.value}
                    label={opt.label}
                    icon={opt.icon}
                    isActive={productScope === opt.value}
                    onClick={() => handleSelect(opt.value)}
                    showRightBorder={idx < options.length - 1}
                />
            ))}
        </Box>
    );
}
